module.exports = __webpack_public_path__ + "static/img/logo_wordmark_white.e434f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_wordmark_white.png
// module id = AyK7
// module chunks = 15